import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBlock: theme.spacing(1),
  },
}))

export default useStyles
